import BvBadge from 'volta/components/bv-badge';
import BvIcon from 'volta/components/bv-icon';
import BvInlineEdit from 'volta/components/bv-inline-edit';
import BvTooltip from 'volta/components/bv-tooltip';
import BaseCell from './base-cell';

import type { TemplateOnlyComponent } from '@ember/component/template-only';

interface CellLabelsCellSignature {
  Args: {
    cell: unknown;
    column: unknown;
    row: unknown;
    scrollToRow: unknown;
  };
}

const CellLabelsCellComponent = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <BaseCell
    @cell={{@cell}}
    @row={{@row}}
    @column={{@column}}
    @scrollToRow={{@scrollToRow}}
    class='tags-cell'
    as |baseCell|
  >
    {{#if baseCell.value.length}}
      <BvInlineEdit @hideDefaultActions={{true}} @withDisplay={{true}} @stopPropagation={{true}}>
        <:default>
          {{#each baseCell.value as |labelCell|}}
            {{#if labelCell.label}}
              <BvBadge
                @color={{labelCell.color}}
                @onClick={{labelCell.onClick}}
                class='u-my-1 u-mr-1'
              >
                {{#if labelCell.icon}}
                  <BvIcon @glyph={{labelCell.icon}} @size='sm' class='u-mr-1' />
                {{/if}}
                {{labelCell.label}}
                {{#if labelCell.iconRight}}
                  <BvIcon @glyph={{labelCell.iconRight}} @size='sm' class='u-my-1' />
                {{/if}}
                {{#if labelCell.tooltipText}}
                  <BvTooltip @text={{labelCell.tooltipText}} @side={{labelCell.tooltipSide}} />
                {{/if}}
              </BvBadge>
            {{/if}}
          {{/each}}
        </:default>
      </BvInlineEdit>
    {{/if}}
  </BaseCell>
</template> satisfies TemplateOnlyComponent<CellLabelsCellSignature>;

export default CellLabelsCellComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Cell::LabelsCell': typeof CellLabelsCellComponent;
    'cell/labels-cell': typeof CellLabelsCellComponent;
  }
}
